import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-48906fd3")

_pushScopeId("data-v-48906fd3")
const _hoisted_1 = { class: "pay-failed" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("img", {
      src: require('@/assets/image/failed.png')
    }, null, 8, ["src"]),
    _createVNode("p", null, _toDisplayString(_ctx.$wordList.SubmitFailed), 1)
  ]))
})